<template>
  <div class="notification-container" :class="show ? 'show' : ''">
    <p class="text-white">You have already entered this letter</p>
  </div>
</template>

<script>
export default {
  props: { show: { type: Boolean, default: false } },
}
</script>

<style scoped>
.notification-container {
  background-color: transparent;
  border-radius: 10px 10px 0 0;
  padding: 15px 20px;
  position: absolute;
  bottom: -50px;
  transition: transform 0.3s ease-in-out;
}
.notification-container p {
  margin: 0;
}

.notification-container.show {
  transform: translateY(-150px);
}
</style>
